module.exports = __webpack_public_path__ + "img/empty-content.png?0b282818";